import {Text} from '@primer/react-brand'
import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, MARKS, type Document} from '@contentful/rich-text-types'

export const renderWithNoMarks = (heading: Document) => {
  return documentToReactComponents(heading, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
    },
  })
}

export const renderWithSpans = (heading: Document, className?: string) => {
  return documentToReactComponents(heading, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <span className={className}>{children}</span>,
    },
  })
}

export const renderPoints = (heading: Document) => {
  return documentToReactComponents(heading, {
    renderMark: {
      [MARKS.BOLD]: text => <Text variant="default">{text}</Text>,
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Text as="p" variant="muted">
          {children}
        </Text>
      ),
    },
  })
}
